(ns rothko.css.browser
  (:require [garden.core :as garden]))

(def style-db (atom {}))

(defn style-tag!
  [class]
  (if-let [node (.getElementById js/document class)]
    node
    (let [node (doto (.createElement js/document "style")
                 (.setAttribute "id" class))]
      (.appendChild (.-head js/document) node)
      node)))

(defn set-style-tag!
  [tag-id css]
  (-> (style-tag! tag-id)
      (.-innerHTML)
      (set! css)))

(defn create-rule-set
  [class declarations]
  (garden/css [(str "." class) declarations]))

(defn set-style!
  [class declarations]
  (when (not= (get @style-db class) declarations)
    (swap! style-db assoc class declarations)
    (set-style-tag! class (create-rule-set class declarations))))
